import { api, unwrap, repeatedParams } from './http';

export default {
  list: async (params = {}, config = {}) => unwrap(api.get('/MembersLogs', params, config)),

  getById: async (id) => unwrap(api.get(`/MembersLogs/${id}`)),

  create: async (payload) => unwrap(api.post('/MembersLogs', payload)),

  update: async (id, payload) => unwrap(api.put(`/MembersLogs/${id}`, payload)),

  // Server PUTs to collection endpoint, not /:id
  save: async (payload) => unwrap(api.put('/MembersLogs', payload)),

  remove: async (id) => unwrap(api.delete(`/MembersLogs/${id}`)),

  bulkDelete: async (ids) => unwrap(api.delete('/MembersLogs', repeatedParams('ids', ids))),

  getTodayCheckinsCount: async () => unwrap(api.get('/MembersLogs/GetNumberofTodayCheckins')),

  getLogsLine: async (params = {}) => unwrap(api.get('/MembersLogs/Line', params)),

  getLastLogs: async (params = {}) => unwrap(api.get('/MembersLogs/Logs/Last', params)),

  // Backfill for the real-time gate-entry popup hub.
  // Returns entries since `since` (UTC ISO string) for the given branch.
  getRecent: async (params = {}) => unwrap(api.get('/member-entries/recent', params)),
};
